import script from "./Confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirm.vue?vue&type=script&setup=true&lang=js"

import "./Confirm.vue?vue&type=style&index=0&id=5967e9b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5967e9b4"]])

export default __exports__